export const migrateToV4 = ()=>{
    return [
        {
            id: 'Admin-1',
            type: 'Admin',
            commonAdminModelVersion: 5
        }
    ];
};

//# sourceMappingURL=v4.js.map